import { useState, useEffect } from 'react'
import debounce from '@doveconviene/sf-web-js-sdk/debounce'

const getSize = () => ({
  height: window.innerHeight,
  width: window.innerWidth,
})

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(getSize())

  const handleResize = debounce(() => setWindowSize(getSize()), 50)

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  return windowSize
}

export default useWindowSize
